import $ from 'jquery';

let chapo = document.querySelector(".chapo");
let body = document.querySelector("body");

// Check if chapo is present on the page
(chapo !== null) ? '' : body.classList.add('no-chapo');
